/* eslint-disable import/no-cycle */
import React from 'react';

import { DEPARTMENT_KEYS } from '../shared/comeet/comeet_api/constants';
import { LayoutBlock } from './CMSComponents/LayoutBlock';
import { Container, HeroBanner, MediaGallery } from './CMSComponents';
import { IFrame } from './CMSComponents/IFrame';
import { PortraitTilesCarousel } from './CMSComponents/PortraitTilesCarousel';
import { PortraitTile } from './CMSComponents/PortraitTile';
import { Benefits } from './CMSComponents/Benefits';
import { BenefitsItem } from './CMSComponents/BenefitsItem';

export const LINKS = {
    LIFE_AT_FIVERR: 'life-at-fiverr',
    TEAMS: 'teams',
    BASE_URL: 'jobs',
    APPLIED: 'thankyou',
};

export const PAGE_NAMES = {
    HOME: 'Careers at Fiverr',
    LIFE_AT_FIVERR: 'Life at Fiverr',
    TEAMS: 'All Positions',
    TEAM: 'Team Page',
    JOBS: 'Position Page',
    APPLIED: 'Position Application Confirmation',
};

export const COPIES = {
    teams: {
        [DEPARTMENT_KEYS.Technology]: 'Technology',
        [DEPARTMENT_KEYS.BI]: 'Data',
        [DEPARTMENT_KEYS.Marketing]: 'Marketing',
        [DEPARTMENT_KEYS['Customer Journey']]: 'Customer Care and\nTrust & Safety',
        [DEPARTMENT_KEYS['G&A']]: 'Legal, HR and Operations',
        [DEPARTMENT_KEYS.Product]: 'Product',
        [DEPARTMENT_KEYS.Design]: 'Design',
        [DEPARTMENT_KEYS.Finance]: 'Finance',
        [DEPARTMENT_KEYS['Marketplace Business Operations']]: 'Business',
        [DEPARTMENT_KEYS.Sales]: 'Sales',
        [DEPARTMENT_KEYS.IT]: 'Cyber, IT and MIS',
    },
    teamsDescriptions: {
        [DEPARTMENT_KEYS.Technology]: 'Perfecting the platform and applications with cutting-edge technologies',
        [DEPARTMENT_KEYS.BI]: 'The launchpad for successful data careers',
        [DEPARTMENT_KEYS.Marketing]: 'Living and breathing the Fiverr brand',
        [DEPARTMENT_KEYS['Customer Journey']]: 'The front line of consumer experience',
        [DEPARTMENT_KEYS['G&A']]: 'The backbone of Fiverr’s culture',
        [DEPARTMENT_KEYS.Product]: 'Make an impact on the way the world works together',
        [DEPARTMENT_KEYS.Design]: 'Cultivate your creative career on a global stage',
        [DEPARTMENT_KEYS.Finance]: 'Bills, Budgets, Balances, and Beyond',
        [DEPARTMENT_KEYS['Marketplace Business Operations']]:
            'Leading global expansion to level the professional playing field',
        [DEPARTMENT_KEYS.Sales]: 'Recognize opportunities to widen Fiverr’s impact',
        [DEPARTMENT_KEYS.IT]: 'Make an impact through cutting edge technology',
    },
    careersAtFiverr: 'Careers at Fiverr',
    lifeAtFiverr: 'Life at Fiverr',
    teamsLabel: 'Teams',
    see_all_positions: 'See All Positions',
    openings: 'openings',
    openPositions: 'open positions across all offices and {teams}',
    filters: {
        search: 'Search by role or keyword',
        allTeams: 'All teams',
        allLocations: 'All locations',
    },
};

export const getEmbeddedComponents = ({ comeetPositions, queryParams, teamId } = {}) => ({
    /* eslint-disable-next-line react/display-name*/
    careersPageContainer: ({ ...props }) => <Container {...props} />,
    /* eslint-disable-next-line react/display-name*/
    designSystemRichTextHeroMedia: ({ ...props }) => <HeroBanner {...props} />,
    /* eslint-disable-next-line react/display-name*/
    mediaGallery: ({ ...props }) => <MediaGallery {...props} />,
    /* eslint-disable-next-line react/display-name*/
    portraitTilesCarousel: ({ ...props }) => <PortraitTilesCarousel {...props} />,
    /* eslint-disable-next-line react/display-name*/
    portraitTile: ({ ...props }) => <PortraitTile {...props} />,
    /* eslint-disable-next-line react/display-name*/
    benefits: ({ ...props }) => <Benefits {...props} />,
    /* eslint-disable-next-line react/display-name*/
    benefitsItem: ({ ...props }) => <BenefitsItem {...props} />,
    /* eslint-disable-next-line react/display-name*/
    layoutBlock: ({ ...props }) => <LayoutBlock {...props} />,
    /* eslint-disable-next-line react/display-name*/
    iframe: ({ ...props }) => (
        <IFrame comeetPositions={comeetPositions} queryParams={queryParams} teamId={teamId} {...props} />
    ),
});
